/**
 * ROC van Twente
 *
 * @author Robuust
 * @author Gijs Stegehuis <gijs@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  /**
   * Select experience date.
   *
   * @param {Event} e
   */
  select(e) {
    this.dispatch('select', { detail: { id: e.params.id } });
  }

  /**
   * Change selected experience day entry.
   *
   * @param {Event} e
   */
  change({ detail: { id } }) {
    this.inputTarget.value = id;
  }
}
